<glxy-form-field [suffixIcon]="includeIcon ? 'access_time' : ''" [bottomSpacing]="bottomSpacing">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input
    matInput
    [formControl]="innerControl"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [errorStateMatcher]="controlErrorMatcher"
  />
  <glxy-error *ngIf="innerControl.invalid">
    {{ 'FRONTEND.FORMS.TIME_PICKER.ENTER_VALID_TIME' | translate }}
  </glxy-error>
</glxy-form-field>

<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
  <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
    {{ displayFn(option) }}
  </mat-option>
</mat-autocomplete>
